<template>
  <div class="wrapper">
    <header class="header">
      <ElSkeleton
        animated
        style="
          --el-skeleton-circle-size: 32px;
          --el-fill-color: #ebebeb;
          width: 32px;
        "
      >
        <template #template>
          <ElSkeletonItem variant="circle" />
        </template>
      </ElSkeleton>

      <ElSkeleton
        animated
        width="100%"
        height="17px"
      >
        <template #template>
          <div class="header__info">
            <ElSkeletonItem
              variant="text"
              style="width: 100%; height: 17px; --el-fill-color: #ebebeb"
            />
            <ElSkeletonItem
              variant="text"
              style="width: 33%; height: 17px; --el-fill-color: #ebebeb"
            />
          </div>
        </template>
      </ElSkeleton>
    </header>

    <div
      class="images"
      :class="size"
    >
      <div
        v-if="size === SizeSkeletonCard.M"
        class="optional-block"
      >
        <div
          v-for="item in 3"
          :key="item"
          class="images__item"
        >
          <div class="images__item__picture">
            <img
              src="/img/empty/skeleton.png"
              alt="skeleton-card"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElSkeleton, ElSkeletonItem } from 'element-plus';
import { SizeSkeletonCard } from '../constants';

interface Props {
  size: SizeSkeletonCard;
}

withDefaults(defineProps<Props>(), {
  size: SizeSkeletonCard.X,
});
</script>

<style scoped lang="scss">
@import "@/assets/style/include";
.wrapper {
  background-color: $bgLight4;
  border-radius: 8px;
  min-width: 100%;
  .header {
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 8px;
    background-color: $bgLight4;
    padding: 12px 20px;

    &__info {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }
  .images {
    background-color: $color-white;
    border-radius: 0 0 8px 8px;
    padding: 12px 0 24px;

    .optional-block {
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: center;
      flex-wrap: wrap;
    }

    &__item {
      min-height: 172px;
      min-width: 265px;
      border: 1px solid $bgLight2;
      border-radius: 8px;
      background-color: $bgLight4;

      &__picture {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 135px;
        background-color: $bgLight2;
        img {
          width: 64px;
          height: 54px;
        }
      }
    }
  }
  .x {
    min-height: 60px;
  }
  .s {
    min-height: 176px;
  }
  .m {
    min-height: 203px;
  }
}
</style>
